const types = {
  ALL_HORARIOS_RESERVA: "@reserva/ALL",
  ALL_CARROS: "@carros/ALL",
  ALL_CARROS_CLIENTE_RESERVA: "@reserva/ALLCLIENTES",
  UPDATE_HORARIO_RESERVA: "@reserva/UPDATE",
  FILTER_HORARIO_RESERVA: "@reserva/FILTER",
  ADD_HORARIO_RESERVATION: "@reserva/ADD",
  RESET_HORARIO_RESERVA: "@reserva/RESET",
  ALL_SERVICES_RESERVA: "@reserva/ALL_SERVICES",
  REMOVE_HORARIO_RESERVA: "@reserva/REMOVE",
};

export default types;
